import type { ColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useDefaultSelectedElementDesignation } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";

import ColorSelector from "./ColorSelector";

interface TextColorModifierProps {
  onChange: (modifiers: ColorModifierValue[]) => void;
}

const TextColorModifierComponent: React.FC<TextColorModifierProps> = ({
  onChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  const currentColor =
    defaultDesignation?.element.styleOverrides?.colorHex ?? null;

  const handleColorChange = (color: string | null) => {
    const modifier: ColorModifierValue = {
      type: "color",
      value: color,
    };
    onChange([modifier]);
  };

  return <ColorSelector value={currentColor} onChange={handleColorChange} />;
};

export default TextColorModifierComponent;
